import { render, staticRenderFns } from "./memberSearch.vue?vue&type=template&id=2f64a3f4&scoped=true&"
import script from "./memberSearch.vue?vue&type=script&lang=js&"
export * from "./memberSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f64a3f4",
  null
  
)

export default component.exports